import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import { LandingPage } from './components/LandingPage';
import { useEffect } from 'react';

import { logEvent } from './utils/analytics';

function MembersRedirect() {
  useEffect(() => {
    logEvent(
      'Redirect',
      'Members',
      undefined,
      undefined,
      'members_redirect',
      undefined,
      { from: window.location.href, to: 'https://sta.supercast.com/' }
    );
    window.location.replace('https://sta.supercast.com/');
  }, []);
  return null;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/start" element={<LandingPage />} />
        <Route path="/members" element={<MembersRedirect />} />
      </Routes>
    </Router>
  );
}

export default App;
